import { RootState } from "@/app/store"
import x from "/src/assets/X.png"

export default function Error() {
  const errMsg = useAppSelector((state: RootState) => state.app.errMsg)
  const t = useTranslate()
  const te = useTranslateExist()

  const txnGA = useAppSelector((state: RootState) => {
    return { ...state.app.txnGA, invoiceQRCode: state.app.invoiceQRCode }
  })

  console.log(txnGA)
  window.gtag("event", "error_page", {
    errorMessage: te(errMsg) ? t(errMsg) : errMsg,
    ...txnGA,
  })

  return (
    <div className="body">
      <div className="centered-container">
        <div className="w-14 h-14 mx-auto mb-8">
          <img className="object-contain" src={x} />
        </div>
        <div className="font-bold text-lg">{t("ERROR")}</div>
        {errMsg && <div>{te(errMsg) ? t(errMsg) : errMsg}</div>}
      </div>
    </div>
  )
}
